import * as yup from 'yup'

import { 
    EMAIL_REGEX_FORMAT,
    trimmedInputValues,
    capitalizeWordsInValue,
} from '../utils';


const PostRequirementSchem = yup.object().shape({
    bussinessTypeId: yup.number().required('Please select bussiness type'),
    orderTypeId: yup.number().required('Please select order type'),
    companyId: yup.number().required('Please select company'),
    branchId: yup.number().required('Please select branch'),
    pmWarehouseId: yup.number().required("Please select warehouse"),
    gstinId: yup.string().required('Please select gstin').trim(),
    userId: yup.number().required('Please select user'),
    shipAddrId: yup.number().required('Please select shipping address'),
    billAddrId: yup.number().required('Please select billing address'),
    isRouted: yup.string().required('Please select routed'),
    reqTagId: yup.number().required('Please select requirement tag'),
    requirementDate: yup.date().required('Please select date'),
    reqSource: yup.string().required("Please select requirement source"),
    pmBranchId: yup.number().required('Please select procmart branch'),
    // reqSourceDoc: yup.string().required("Please upload requirement source document")
    clientReqNo: yup.string().when("isIncrementalReq", {
        is: true,
        then: () => yup.string().required("Please enter client Req No."),
        otherwise: () => yup.string().nullable()
    })
})

const addNewCompanySchema = yup.object().shape({
    companyName: yup.string()
        .transform((value) => capitalizeWordsInValue(value))
        .required('Please enter company name')
        .transform((value) => trimmedInputValues(value)),
    branchName: yup.string()
        .transform((value) => capitalizeWordsInValue(value))
        .required('Please enter branch name')
        .transform((value) => trimmedInputValues(value)),
    // gstinCode: yup.string().when("urpCheck", {
    //     is: false,
    //     then: () => yup.string()
    //         .transform((value) => trimmedInputValues(value)) 
    //         .test('len', 'Must be exactly 15 characters', value => value.length === 15)
    //         .required('Please enter gstin-no'),
    //     otherwise: () => yup.string()
    //         .transform((value) => '')
    //     }),
    hodFirstName: yup.string()
        .transform((value) => trimmedInputValues(value))
        .required('Please enter hod first name'),
    hodLastName: yup.string()
        .transform((value) => trimmedInputValues(value))
        .required('Please enter hod last name'),
    hodEmail: yup.string()
        .transform((value) => trimmedInputValues(value))
        .lowercase()
        .matches(EMAIL_REGEX_FORMAT, 'Please enter valid email')
        .required('Please enter hod email'),
    hodISDCode: yup.string()
        .transform((value) => trimmedInputValues(value))
        .required('Please select ISD Code'),
    hodPhoneNo: yup.string()
        .test('len', 'Must be exactly 10 numbers', value => value.length === 10)
        .required('Please enter hod phone no'),
    address: yup.string()
        .transform((value) => trimmedInputValues(value))
        .required('Please enter first address'),
    // addressLine2: yup.string()
    //     .transform((value) => trimmedInputValues(value))
    //     .required('Please enter second address'),
    pinCode: yup.string()
        .transform((value) => trimmedInputValues(value))
        .required('Please enter the pincode')
        .test('pincodeLength', function(value) {
            const pmCompanyConfig = this.options.context
            
            const pinCodeLength = pmCompanyConfig.pinCodeLength
            const pinCodeErrorMessage = `Must be exactly ${pinCodeLength} characters`;
            
            if (value && value.length !== pinCodeLength) {
              return this.createError({ message: pinCodeErrorMessage })
            }
            return true
        }),
    stateId: yup.number().required('Please select state'),
    countryId: yup.number().required('Please select country'),
    city: yup.string()
        .transform((value) => capitalizeWordsInValue(value))
        .transform((value) => trimmedInputValues(value))
        .required('Please enter city'),
})


const postRequirementInitialState = {
    bussinessTypeId: 1,
    orderTypeId: null,
    companyId: null,
    branchId: null,
    pmWarehouseId: null,
    gstinId: null,
    userId: null,
    shipAddrId: null,
    billAddrId: null,
    isRouted: '',
    reqTagId: 3,
    requirementDate: null,
    reqSource: "",
    reqSourceDoc: null,
    pmBranchId: null,
    isTaxExempted: null,
    isRCAutomated: false,
    clientReqNo: null
}

const companyInitialState = {
    // Get userId from hodEmail, and panCode from gstin 
    companyName: '',
    companyDescription: '',
    companyShortName: '',
    webpage: '',
    countryId: null,
    buyerSeller: 1,
    isBuyer: true,
    branchName: '',
    gstinCode: '',
    hodFirstName: '',
    hodLastName: '',
    hodEmail: '',
    hodPhoneNo: '',
    address: '',
    // addressLine2: '',
    pinCode: '',
    panCode: '',
    city: '',
    stateId: null,
    companyGSTINs: []
}

export { PostRequirementSchem, postRequirementInitialState, addNewCompanySchema, companyInitialState };